import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../services/api.service';

export interface IDevolutiva {
    uuid: string;
    data_criacao: string;
    status: 'processando' | 'sucesso' | 'erro';
    devolutiva: string | null;
    erro_msg: string | null;
}   

@Injectable()
export class DevolutivaService {
    private baseUrl = `devolutiva`;

    constructor(protected apiService: ApiService) {}

    public gerarDevolutiva(idLicenca: string) {
        return this.apiService.post(this.baseUrl, {licenca: idLicenca}) as unknown as Observable<IDevolutiva>;
    }

    public getDevolutiva(idLicenca: string) {
        return this.apiService.get(`${this.baseUrl}/${idLicenca}`) as unknown as Observable<IDevolutiva>;
    }

}
